export const objectsData = [
    {
        id: 1,
        name: "Нечуя-Левицького 23",
        coords: [50.41424, 30.49015],
        images: [
            "/object/nl/nl1.jpg", "/object/nl/nl2.jpg", "/object/nl/nl3.jpg",
            "/object/nl/nl4.jpg", "/object/nl/nl5.jpg", "/object/nl/nl6.jpg",
            "/object/nl/nl7.jpg", "/object/nl/nl8.jpg", "/object/nl/nl9.jpg",
            "/object/nl/nl10.jpg", "/object/nl/nl11.jpg", "/object/nl/nl12.jpg",
            "/object/nl/nl13.jpg", "/object/nl/nl14.jpg"
        ],
        minAge: 25,
        suitableFor: [
            "Сімейних свят", "Днів народження", "Весілля та хрестин",
            "Корпоративів та ювілеїв", "Семінарів та тренінгів",
            "Лекцій та майстер-класів", "Ретритів та конференцій",
            "Інших культурних заходів"
        ],
        rules: "1. Здаю будинок у чистоті та порядку. Приймаю будинок чистим. Або наше прибирання 1000грн.\n2. Надто гучна музика на подвір'ї заборонена.\n3. Куріння сигарет, кальяну, айкосу в будинку заборонено.\n4. Режим тиші на ділянці з 22:00 до 09:00 обов'язковий.",
        price: "9 000 грн/доба",
        extra: "!!! При відсутності світла є: автономне газове опалення, гаряча та холодна вода, частково світло, газова плита."
    }
];

export const buttonsData = [
    { id: 1, label: 'Реєстрація ФОП', img: '/icon/doc.png', text: '...' },
    { id: 2, label: 'Юридичний та бухгалтерський супровід', img: '/icon/scales.png', text: '...' },
    { id: 3, label: 'Підготовка оселі під оренду та подальший контроль', img: '/icon/house.png', text: '...' },
    { id: 4, label: 'Пошук орендарів', img: '/icon/people.png', text: '...' },
];